import { Fragment } from 'react'
import { SelectFilterDefinition } from '../types'
import { Text } from '$components'
import { CheckIcon } from '$components'
import { useFilters } from '../hooks/use-filters'

export type SelectFilterOptionProps = {
  filter: SelectFilterDefinition
}

export function SelectFilterOption({ filter }: SelectFilterOptionProps) {
  const { setFilter, getFilter } = useFilters()

  return (
    <Fragment>
      { filter.options.map((option) => (
        <button
          key={option.id}
          className="w-full p-4 sm:px-3 sm:py-2 focus:outline-none hover:bg-gray-50/50 flex items-center gap-3 justify-between cursor-pointer hover:rounded-xl sm:hover:rounded-none"
          onClick={(e) => {
            e.preventDefault()

            setFilter(filter, option.id)
          }}
        >
          <div className="flex items-center gap-2 min-w-0">
            {option.icon && (
              <div className="flex-shrink-0">
                {option.icon}
              </div>
            )}

            <Text
              type="s"
              className="truncate"
            >
              { option.label }
            </Text>
          </div>

          { option.id === getFilter(filter) && (
            <CheckIcon className="size-4 text-indigo-400" />
          )}
        </button>
      ))}
    </Fragment>
  )
}
